module.exports = __webpack_public_path__ + "static/media/panco_02.d346daf9.jpg";